// components
import CardTemplates from '@components/_molecules/CardTemplates';
import { useTranslation } from 'next-i18next';
import TableLabel from './TableLabel';
import styled from '@emotion/styled';
import TableItem from './TableItem';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import { primary } from '@styles/Colors';

export type TotalDataType = {
  type: string;
  quantity: string;
  request_quantity?: string;
  supply_price: string;
  vat: string;
  total_price: string;
};

type Props = {
  data: TotalDataType[];
  currency?: string;
};

const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const UnitWrapper = styled.div`
  display: flex;
  gap: 8px;
`;

export default function TotalCard({ data, currency }: Props) {
  const { t } = useTranslation('component');

  return (
    <CardTemplates
      title={t('totalCard.title')}
      titleOption={
        currency === 'USD' && (
          <UnitWrapper>
            <Typography variant={TypoVariant.MH2}>Unit : </Typography>
            <Typography variant={TypoVariant.SH2} color={primary.blue}>
              USD
            </Typography>
          </UnitWrapper>
        )
      }>
      <Content>
        <TableLabel currency={currency} />

        {data.map((item, idx) => (
          <TableItem data={item} isLast={idx === data.length - 1} key={idx} currency={currency} />
        ))}
      </Content>
    </CardTemplates>
  );
}
